 const postTypes = {
 GET_ALL : "GET_ALL",
 ADD_POST:"ADD_POST",
 REMOVE_POST:"REMOVE_POST",
 USER_POSTS:"USER_POSTS",
 LIKE_UNLIKE_POST :"LIKE_UNLIKE_POST",
 ADD_DELET_POST:"ADD_DELET_POST",
 USER_IMAGES:"USER_IMAGES",
 USER_VIDEOS:"USER_VIDEOS",
 ADD_DELETE_COMMENT:"ADD_DELETE_COMMENT"
}
export default postTypes;